export default __webpack_public_path__ + "static/media/gb.db996f64.png";